import { useEffect, useRef, useState } from 'react'
import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useActions, useErrorModal, useTypedSelector } from 'hooks'
import { FORM_TYPES } from 'app/auth/constants'
import useShowQrModal from './useShowQrCodeModal'
import { requests } from '@fable/api'

const useClubDetailJoinButtonForInvite = ({
  joined,
  state,
  machine,
}: {
  joined: boolean
  state: any
  machine: any
}) => {
  const [inviteError, setInviteError] = useState<Error | undefined>()
  const { showQrCodeModal } = useShowQrModal(state)
  const { colors } = useTheme()
  const ctx = state.context
  const { openAuthModal } = useActions()
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { profile } = useTypedSelector(({ user }) => user)
  const shouldJoinPostAuth = useRef(false)
  const shouldShowPostJoinModal = useRef(false)
  const title = 'Join the book club'

  useEffect(() => {
    if (joined && shouldShowPostJoinModal.current) {
      showQrCodeModal()
      shouldShowPostJoinModal.current = false
    }
  }, [joined, showQrCodeModal])

  useEffect(() => {
    if (shouldJoinPostAuth.current && !!profile.data && !joined) {
      machine.send({
        type: 'JOIN',
        data: { postAuth: true, user: profile.data },
      })
      shouldJoinPostAuth.current = false
    }
  }, [isAuthenticated, joined, machine, profile.data, showQrCodeModal])

  useErrorModal(inviteError)

  const showAuthStep = () => {
    openAuthModal(FORM_TYPES.SIGN_UP, null, [], {
      invite: ctx.invite,
      header: (
        <div>
          <Text
            className={css`
              text-transform: uppercase;
            `}
            type="label"
            sizing="M"
            color={`${colors.graphite}66`}
            align="center"
          >
            Step 1
          </Text>
        </div>
      ),
    })
  }

  const handleClick = async () => {
    if (!joined) {
      shouldShowPostJoinModal.current = true
      if (!ctx.user) {
        shouldJoinPostAuth.current = true
        showAuthStep()
        return
      }

      try {
        await requests.getClubInvite({
          invite: ctx.invite,
          email: ctx.user.email,
        })
      } catch (error: unknown) {
        setInviteError(error as Error)
        return
      }

      machine.send('JOIN')
    } else {
      showQrCodeModal()
    }
  }

  return {
    handleClick,
    title,
  }
}

export default useClubDetailJoinButtonForInvite
